import I18n from 'lib/i18n/i18n';

export default function() {
    return (
        I18n.getString('conversationFlow')
    )
}